export const EVENTS = {
  INBOX: {
    NOTIFICATIONS_LOAD: 'inbox.notifications_load',
    NOTIFICATIONS_LOADING: 'inbox.notifications_loading',
    NOTIFICATIONS_LOADED: 'inbox.notifications_loaded',
    NOTIFICATIONS_LOAD_ERROR: 'inbox.notifications_load_error',

    NOTIFICATION_MARK_READ: 'inbox.notification_mark_read',
    NOTIFICATION_MARKING_READ: 'inbox.notification_marking_read',
    NOTIFICATION_MARKED_READ: 'inbox.notification_marked_read',
    NOTIFICATION_MARK_READ_ERROR: 'inbox.notification_mark_read_error',

    NOTIFICATION_MARK_ALL_READ: 'inbox.notification_mark_all_read',
    NOTIFICATION_MARKING_ALL_READ: 'inbox.notification_marking_all_read',
    NOTIFICATION_MARKED_ALL_READ: 'inbox.notification_marked_all_read',
    NOTIFICATION_MARK_ALL_READ_ERROR: 'inbox.notification_mark_all_read_error',

    NOTIFICATION_DELETE: 'inbox.notification_delete',
    NOTIFICATION_DELETING: 'inbox.notification_deleting',
    NOTIFICATION_DELETED: 'inbox.notification_deleted',
    NOTIFICATION_DELETE_ERROR: 'inbox.notification_delete_error',

    NOTIFICATION_FILTER_CHANGE: 'inbox.notification_filter_change'
  }
};

export const ENDPOINTS = {
  INBOX: {
    NOTIFICATIONS: 'https://api.monrapidoo.com/message/list/user?group=ultraxeno&service=rapidoo&target=user',
    MARK_READ: 'https://api.monrapidoo.com/message/mark/read/:notificationId',
    MARK_ALL_READ: 'https://api.monrapidoo.com/message/mark/all/read',
    DELETE: '/api/notifications/:notificationId' // Not provided in docs, keeping as is
  }
};

export const NOTIFICATION_TYPES = {
  ALL: 'all',
  ORDER: 'order',
  PROMOTION: 'promotion',
  SYSTEM: 'system',
  PAYMENT: 'payment',
  DELIVERY: 'delivery'
};

export const NOTIFICATION_ICONS = {
  order: '/images/icons/notification-order.svg',
  promotion: '/images/icons/notification-promotion.svg',
  system: '/images/icons/notification-system.svg',
  payment: '/images/icons/notification-payment.svg',
  delivery: '/images/icons/notification-delivery.svg',
  default: '/images/icons/notification-default.svg'
};

export const NOTIFICATION_FILTERS = [
  { id: NOTIFICATION_TYPES.ALL, label: 'Toutes', icon: '/images/icons/filter-all.svg' },
  { id: NOTIFICATION_TYPES.ORDER, label: 'Commandes', icon: '/images/icons/filter-order.svg' },
  { id: NOTIFICATION_TYPES.PROMOTION, label: 'Promotions', icon: '/images/icons/filter-promotion.svg' },
  { id: NOTIFICATION_TYPES.SYSTEM, label: 'Système', icon: '/images/icons/filter-system.svg' },
  { id: NOTIFICATION_TYPES.PAYMENT, label: 'Paiements', icon: '/images/icons/filter-payment.svg' },
  { id: NOTIFICATION_TYPES.DELIVERY, label: 'Livraisons', icon: '/images/icons/filter-delivery.svg' }
];
